import React from 'react';
import '../../styles/TextInput.css';

/**
 * Styled text input component that matches CustomSelect height and styling
 * 
 * @param {string} value - Current input value
 * @param {function} onChange - Called with event { target: { value, name } }
 * @param {string} name - Form field name
 * @param {string} type - Input type (text, email, tel, number, etc.)
 * @param {string} placeholder - Placeholder text
 * @param {boolean} disabled - Whether the input is disabled
 * @param {string} className - Additional CSS classes
 * @param {number} maxLength - Maximum character length
 * @param {string} id - Input id for label association
 * @param {boolean} required - Whether the field is required
 * @param {string} autoComplete - Autocomplete attribute
 * @param {React.ReactNode} icon - Optional icon to display on the left
 * @param {React.ReactNode} suffix - Optional element to display on the right
 */
function TextInput({ 
  value = '', 
  onChange, 
  name,
  type = 'text',
  placeholder = '',
  disabled = false,
  className = '',
  maxLength,
  id,
  required = false,
  autoComplete,
  icon,
  suffix
}) {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div className={`text-input ${disabled ? 'disabled' : ''} ${icon ? 'has-icon' : ''} ${suffix ? 'has-suffix' : ''} ${className}`}>
      {icon && <span className="text-input-icon">{icon}</span>}
      <input
        type={type}
        id={id}
        name={name}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
        required={required}
        autoComplete={autoComplete}
        className="text-input-field"
      />
      {suffix && <span className="text-input-suffix">{suffix}</span>}
    </div>
  );
}

export default TextInput;
